module.exports = __webpack_public_path__ + "img/员工大会.c482a59b.jpg";